// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"96be2721","703":"6276d6f4"}[chunkId] + ".chunk.js";
};